import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async';
import BreadcrumbBack from '../../../../../components/breadcrumb/BreadcrumbBack';
import CustomButton from '../../../../../components/button/CustomButton';
import Models from '../../../../../components/models/Models';
import MUITableGrid from '../../../../../components/tables/MUITableGrid';
import DynAccountCE from './DynAccountCE';

export default function DynAccount() {
    const [open, setOpen] = useState(false);
  return (
    <>
    <Helmet>
            <title>{`DynTube Account  | ${window.location.hostname}`}</title>
          </Helmet>
           <BreadcrumbBack title="Manage DynTube Account">
                  <CustomButton
                    title="Create DynTube Account"
                    icon={true}
                    iconName="create"
                    onClick={() => setOpen(!open)}
                  />
                </BreadcrumbBack>
                      <div className="my-2">
                            <MUITableGrid name="adminDynTubeAccount" />
                          </div>
                 <Models name="Create New Account" isOpen={open} isClose={setOpen}>
                        <DynAccountCE type="create" isOpen={setOpen} />
                      </Models>
    </>
  )
}
